import { Route } from '@angular/router';
import { MainLayoutComponent } from './core/layout/main-layout/main-layout.component';
import { isAuthenticatedGuard } from './shared/guard/is-authenticated.guard';
import { isAuthorizedGuard } from './shared/guard/is-authorized.guard';
import { UserType } from './domain/user/model/user-type';
import { PreliminaryLayoutComponent } from './core/layout/preliminary-layout/preliminary-layout.component';

export const appRoutes: Route[] = [
  // ==================== AUTH ROUTES (no guard) ====================
  {
    path: 'auth',
    component: PreliminaryLayoutComponent,
    loadChildren: () =>
      import('./page/auth/auth.routes').then(m => m.authRoutes),
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [isAuthenticatedGuard()],
    children: [
      // {
      //   path: 'dashboard',
      //   loadComponent: () =>
      //     import('./page/dashboard/dashboard.component').then(
      //       c => c.DashboardComponent
      //     ),
      // },
      {
        path: 'profile',
        loadChildren: () =>
          import('./page/profile/profile.routes').then(m => m.profileRoutes),
      },
      {
        path: 'users',
        canActivate: [isAuthorizedGuard(UserType.ADMIN)],
        loadChildren: () => import('./page/user/routes').then(m => m.routes),
      },
      // Settings (Milestone 4) and Messages (Milestone 3) are not delivered yet:
      // a typed address lands on Cases instead of an empty page with an error.
      // Restore the loadChildren below together with their menu entries.
      {
        path: 'settings',
        redirectTo: 'medical-cases',
        pathMatch: 'full',
        // loadChildren: () =>
        //   import('./page/settings/settings.routes').then(m => m.settingsRoutes),
      },
      {
        path: 'messages',
        redirectTo: 'medical-cases',
        pathMatch: 'full',
        // loadChildren: () => import('./page/message/routes').then(m => m.routes),
      },
      // Legacy bookmarks: the ported `case` module was removed (no backend).
      {
        path: 'cases',
        redirectTo: 'medical-cases',
      },
      {
        path: 'medical-cases',
        loadChildren: () =>
          import('./page/medical-case/routes').then(m => m.routes),
      },

      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'medical-cases',
      },
    ],
  },

  {
    path: 'error/not-found',
    loadComponent: () =>
      import('./page/error/not-found/not-found.component').then(
        c => c.NotFoundComponent
      ),
  },

  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth/login',
  },

  // ==================== 404 FALLBACK ====================
  {
    path: '**',
    redirectTo: 'error/not-found',
  },
];
